import withCurrentPath from 'Seo/hocs/with_current_path';
import CanonicalContainer from './canonical_container';

export default withCurrentPath()(CanonicalContainer);
